// The country a phone field starts on when it is empty.
//
// Inside a school's space the page names the school's country
// (<meta name="default-phone-country">): a number typed without its dialling
// code is the school's. Located by the IP address, a Cameroonian school
// reached from France stored 699 000 311 as +33 699 000 311 (QA3 SF-07).
// Elsewhere (public pages) the field still locates the visitor ("auto").
//
// A field may name its own country (data-default-country="cm"), which wins:
// the parent layout declares no school — a parent may have children in
// several — and the mobile money field of a payment to a Cameroonian school
// started on the visitor's country (QA round 4, PAR4-03).
//
// @param {Document} doc
// @param {string} [fieldCountry] the country the field itself names
// @return {string} an ISO 3166-1 alpha-2 code in lower case, or "auto"
export function defaultPhoneCountry(doc = document, fieldCountry = "") {
  const code = (value) => {
    const cleaned = (value || "").trim().toLowerCase();
    return /^[a-z]{2}$/.test(cleaned) ? cleaned : null;
  };
  const declared = doc
    .querySelector('meta[name="default-phone-country"]')
    ?.getAttribute("content");

  return code(fieldCountry) || code(declared) || "auto";
}
